export default [
  {
    path: 'relatorios/resultados-loterias',
    name: 'resultados-loterias',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Resultados Loterias',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Resultados Loterias'},
      ]
    }
  }
]
